// extracted by mini-css-extract-plugin
export var arrow = "language-selector-module--arrow--1de2b";
export var countryLabel = "language-selector-module--countryLabel--d3fa5";
export var displayOnTop = "language-selector-module--displayOnTop--faf50";
export var dropdownContent = "language-selector-module--dropdownContent--d98d8";
export var languageSelector = "language-selector-module--languageSelector--0967c";
export var menuButton = "language-selector-module--menuButton--974ec";
export var submenuButton = "language-selector-module--submenuButton--64828";